import React, { useContext } from 'react';
import "./SalaryControl.css";
import OptionsPanel from 'Components/OptionsPanel/OptionsPanel';
import SalaryPanel from '../SalaryPanel/SalaryPanel';
import BenefitsPanel from '../BenefitsPanel/BenefitsPanel';
import WorkSchedulePanel from '../WorkSchedulePanel/WorkSchedulePanel';
import { AuthContext } from 'Contexts/auth';

const PanelsUserControlBudgtes = ({
  onUpdateWorkScheduleIdSelected,
  workScheduleIdSelected,
  onUpdateResetUserList,
  onUpdateUserSelected,
  onUpdateBenefitsIdSelected,
  benefitsIdSelected,
  usersSelected
}) => {
  const { user } = useContext(AuthContext);
    const currentModule = user.module;

  const options = [
    {
      label: 'Salário',
      component: <SalaryPanel usersSelected={usersSelected} />
    },
    {
      label: 'Benefício',
      component: (
        <BenefitsPanel
          usersSelected={usersSelected}
          onUpdateBenefitsIdSelected={onUpdateBenefitsIdSelected}
          benefitsIdSelected={benefitsIdSelected}
        />
      )
    }
  ];

  if (currentModule == 'OCMT_PRD_BLCT' || currentModule == 'OCMT_PRD_BLCT_QTRZ') {
    options.push({
      label: 'Agenda de trabalho',
      component: (
        <WorkSchedulePanel
          usersSelected={usersSelected}
          onUpdateWorkScheduleIdSelected={onUpdateWorkScheduleIdSelected}
          workScheduleIdSelected={workScheduleIdSelected}
        />
      )
    });
  }

  return (
    <OptionsPanel
      options={options}
      heigthLess={'60px'}
    />
  );
};

export default PanelsUserControlBudgtes;
